const FLAG_STYLE_TAG_CLASSNAME = 'ph-test-variants';
// PostHog configuration
const POSTHOG_DISTINCT_ID_COOKIE_NAME = 'ph_distinct_id';
const POSTHOG_DISTINCT_ID_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year
const POSTHOG_IGNORE_FLAG_PREFIX = 'flag.ignore.';

const POSTHOG_CACHED_DECISION_COOKIE_NAME = 'ph_cached';

const POSTHOG_CACHED_DECISION_COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

const POSTHOG_ENDPOINT_VERSION_NUMBER = 2;

const POSTHOG_FETCH_TIMEOUT_MS = 3000;

export {
    FLAG_STYLE_TAG_CLASSNAME,
    POSTHOG_DISTINCT_ID_COOKIE_NAME,
    POSTHOG_DISTINCT_ID_COOKIE_MAX_AGE,
    POSTHOG_IGNORE_FLAG_PREFIX,
    POSTHOG_CACHED_DECISION_COOKIE_NAME,
    POSTHOG_CACHED_DECISION_COOKIE_MAX_AGE,
    POSTHOG_ENDPOINT_VERSION_NUMBER,
    POSTHOG_FETCH_TIMEOUT_MS,
};
